import { render, staticRenderFns } from "./LabNewsElementCard.vue?vue&type=template&id=3fae6b70&scoped=true"
import script from "./LabNewsElementCard.vue?vue&type=script&lang=js"
export * from "./LabNewsElementCard.vue?vue&type=script&lang=js"
import style0 from "./LabNewsElementCard.vue?vue&type=style&index=0&id=3fae6b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae6b70",
  null
  
)

export default component.exports